const variables = require('variables');

/**
 * Cross-Browser function to take the current height of document
 * @return {int} the height of the viewport
 */
function getHeightWindow() {
	return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}

/**
 * Cross-Browser function to take the current width of document
 * @return {int} the width of the viewport
 */
function getWidthWindow() {
	return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}

/**
 * Function to check if the current window is in Mobile mode (width <= 768px)
 * @return {Boolean} mobile or not
 */
function isMobileWidth() {
	return getWidthWindow() < variables.breakpointsPixels[0];
}

module.exports = { getHeightWindow, getWidthWindow, isMobileWidth };



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/dimension.js
 **/